var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperadminDashboardItemTotalIncomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.815,
    height: 45.757,
    viewBox: "0 0 45.815 45.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graph",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 3.027, 0.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33948",
    d: "M19.135,15.334A18.27,18.27,0,0,0,1.63,0,1.569,1.569,0,0,0,0,1.51H0v.141L.986,16.4A1.811,1.811,0,0,0,2.9,18.09L17.687,17.1a1.569,1.569,0,0,0,1.449-1.69Z",
    transform: "translate(22.12)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33949",
    d: "M13.509.052A2.012,2.012,0,0,1,15.8,1.2a1.811,1.811,0,0,1,.181.664c.2,2.857.624,9.115.865,12.5A2.294,2.294,0,0,0,19.3,16.491h0l12.415-.765a2.012,2.012,0,0,1,2.133,2.012h0A16.922,16.922,0,0,1,2.14,24.761,16.1,16.1,0,0,1,.128,18.6a10.383,10.383,0,0,1-.121-2.012A16.942,16.942,0,0,1,13.488.052",
    transform: "translate(0 8.722)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperadminDashboardItemTotalIncomeIcon);
export default __webpack_public_path__ + "static/media/superadmin-dashboard-item-total-income-icon.56a7b5a89b7d0c8b38929431ffcb81d4.svg";
export { ForwardRef as ReactComponent };